import { render, staticRenderFns } from "./LinkSettings.vue?vue&type=template&id=6453441f&scoped=true&"
import script from "./LinkSettings.vue?vue&type=script&lang=js&"
export * from "./LinkSettings.vue?vue&type=script&lang=js&"
import style0 from "./LinkSettings.vue?vue&type=style&index=0&id=6453441f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453441f",
  null
  
)

export default component.exports